<template>
  <div>
    <v-autocomplete
      :value="vehicleType"
      :items="filterVehicleTypes"
      :label="$i18n.t(label)"
      v-bind="$attrs"
      @change="changedTo"
      ref="select"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
      @click:clear="clear"
      :search-input.sync="filter"
      autocomplete="nope"
      :multiple="multiple"
      :categories="categories"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div ripple class="height32" v-if="multiple === false">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
        <div ripple v-else>
          <div
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >
            {{ data.item.name }}
            <v-icon @click="remove(data.item)">mdi-close</v-icon>
          </div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float: right"
                >mdi-check</v-icon
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { doGet } from "@/store/common/module/apis";
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";
import corpService from "@/store/common/module/CorpService";

@Component({
  name: "VehicleTypeSelect",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Truck Type",
    },
    clearable: {
      default: false,
    },
    multiple: {
      default: false,
    },
    categories: {
      default: false,
    },
    rules: {
      default: () => [],
    },
    bodyType: {
      default: null,
    },
  },
})
export default class VehicleTypeSelect extends (Vue, Themeable) {
  vehicleType = null;
  vehicleTypes = [];
  loading = true;
  filter = "";

  clear() {
    this.filter = "";
    this.vehicleType = null;
    this.$emit("input", null);
  }

  get filterVehicleTypes() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.vehicleTypes;
    const fs = this.vehicleTypes.filter(function (s) {
      return (
        s.disabled || (s.name && s.name.toLowerCase().indexOf(filterby) >= 0)
      );
    });
    return fs;
  }

  changedTo(newVal) {
    if (newVal && newVal._id) {
      this.filter = "";
      if (newVal) {
        this.$emit("input", newVal._id);
        this.$emit("truckTypeName", newVal.name);
      }
    }
    if (Array.isArray(newVal) && newVal.length > 0) {
      this.filter = "";
      const response = [];
      for (let i = 0; i < newVal.length; i++) {
        response.push(newVal[i]._id);
      }
      this.$emit("input", response);
    }
    if (!newVal) this.$emit("input", null);
  }

  selected(val) {
    if (
      val != null &&
      this.value != null &&
      !Array.isArray(this.value) &&
      val._id === this.value &&
      val.name === this.value
    ) {
      return true;
    } else if (
      val != null &&
      this.value != null &&
      Array.isArray(this.value) &&
      (this.value.includes(val._id) || this.value.includes(val.name))
    ) {
      return true;
    }
    return false;
  }

  selectValue() {
    if (this.value) {
      for (let i = 0; i < this.vehicleTypes.length; i++) {
        if (
          typeof this.vehicleTypes[i] === "object" &&
          this.vehicleTypes[i]._id === this.value
        ) {
          this.vehicleType = this.vehicleTypes[i];
          break;
        }
      }
    } else {
      this.vehicleType = null;
    }
  }

  async init() {
    this.filter = "";
    this.loading = true;
    let vehicleTypes;
    if (this.categories) {
      await corpService.populateVehicleCategories();
      vehicleTypes = corpService.vehicleCategories;
      // this.vehicleTypes = await doGet("/api/vtgroup/vehicle/category/map");
    } else {
      await corpService.populateVehicleTypes();
      vehicleTypes = corpService.vehicleTypes;
      // this.vehicleTypes = await doGet("/api/vehicletype/list");
    }
    const fs = vehicleTypes.filter((s) => {
      return this.bodyType == s.bodyType;
    });
    this.vehicleTypes = fs;
    this.loading = false;
    this.selectValue();
  }

  async mounted() {
    await this.init();
    this.loading = false;
  }

  @Watch("value", { immediate: true })
  async onValueChange() {
    await this.init();
  }

  @Watch("bodyType", { immediate: true })
  async onBodyTypeChange() {
    await this.init();
  }

  remove(val) {
    if (val != null && val.name != null && this.vehicleType != null) {
      if (Array.isArray(this.vehicleType)) {
        for (let i = 0; i < this.vehicleType.length; i++) {
          if (
            val.name === this.vehicleType[i].name ||
            val._id === this.vehicleType[i]._id
          ) {
            this.vehicleType.splice(i, 1);
            const response = [];
            for (let i = 0; i < this.vehicleType.length; i++) {
              response.push(this.vehicleType[i].name);
            }
            this.$emit("input", response);
            break;
          }
        }
      }
    }
    return false;
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
</style>
